import { defineComponent, createElementBlock, openBlock, normalizeStyle, renderSlot } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SidebarGroup",
  props: {
    level: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: "sidebar-group sidebar-indent-nested",
        style: normalizeStyle({ "--scalar-sidebar-level": _ctx.level })
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 4);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=SidebarGroup.vue.js.map
